<template>
  <div class="cenario-botao">
    <BotaoPadrao
      arredondadoEsquerda
      class="botao-cenario"
      v-if="numeroCenarios > 1 && id != 1"
      nome="remover"
      icone="trash"
      :click="abreModalRemover"
      :desabilita="travaBotoes"
      cor="vermelho"
    />
    <BotaoPadrao
      arredondadoEsquerda
      class="botao-cenario"
      nome="impressão"
      icone="print"
      :click="imprimirResultado"
      :desabilita="travaBotoes || !resultadoExibido"
      cor="azul"
    />
    <BotaoPadrao
      arredondadoEsquerda
      class="botao-cenario"
      nome="limpar"
      icone="eraser"
      :click="abreModalLimpar"
      :desabilita="travaBotoes"
    />
    <BotaoPadrao
      v-if="blUsuarioPro"
      arredondadoEsquerda
      class="botao-cenario"
      nome="salvar"
      icone="save"
      desabilita
      cor="verde"
      :loading="carregaSalvar"
      tooltip="Opção desabilitada na versão de testes"
    />
    <BotaoPadrao
      v-else
      arredondadoEsquerda
      class="botao-cenario"
      nome="salvar"
      icone="save"
      :click="handleSubmitSalvarCenario"
      :desabilita="travaBotoes"
      cor="verde"
      :loading="carregaSalvar"
    />
    <BotaoPadrao
      arredondadoEsquerda
      v-if="numeroCenarios == 1"
      class="botao-cenario"
      nome="resultado"
      icone="clipboard-list"
      :click="buscarResultado"
      :desabilita="travaBotoes"
      cor="azul"
    />
  </div>
</template>

<script>
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

import { mapGetters } from "vuex";

export default {
  name: "CenarioBotoes",

  components: {
    BotaoPadrao
  },

  props: {
    resultadoExibido: Boolean,
    carregaSalvar: Boolean,
    travaBotoes: Boolean,
    nomeCenario: String,
    id: Number,
    numeroCenarios: Number,
    buscarResultado: Function,
    submitSalvarCenario: Function,
    imprimirResultado: Function,
    dadosForm: Object
  },

  inject: ["pushAlert", "abreModalLimpar", "abreModalRemover"],

  computed: {
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    })
  },

  methods: {
    handleSubmitSalvarCenario() {
      this.submitSalvarCenario(false);
    }
  }
};
</script>

<style lang="scss" scoped>
.cenario-botao {
  display: flex;
  justify-content: flex-end;
  margin: 0.5rem 0 0.5rem 0;
  flex-wrap: wrap;
}
.botao-cenario {
  margin: 7px 0 7px 10px;
}
</style>
